import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { catchError, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { formatFromDate } from 'src/app/common/datetime_utility';
import { ISidepanelTab } from 'src/app/components/sidepanel-tabs/sidepanel-tabs.component';
import { PreventionMockModel } from 'src/app/models/api/preventionMock.model';
import { AiPreventionMockTableRowViewModel } from 'src/app/models/viewModels/aiPreventionMockTableRowViewModel';
import { AiPreventionMockHttpService } from 'src/app/services/httpServices/detection/aiPreventionMockHttpService/ai-prevention-mock-http.service';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ICardField } from 'src/app/models/viewModels/cardModel';

@Component({
  selector: 'app-prevention-details',
  templateUrl: './enterprise-ai-prevention-details.component.html',
  styleUrls: ['./enterprise-ai-prevention-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreventionDetailsComponent {
  public prevention = input.required<PreventionMockModel | string>();
  public showNoData = false;
  public preventionView: AiPreventionMockTableRowViewModel;
  public isLoading = signal<boolean>(true);
  public preventionId: string;
  public integrationId: string;
  public tabs: ISidepanelTab[];
  public activeTabIndex = 0;

  public refreshPrevention$: Subject<PreventionMockModel | string> = new Subject();
  public prevention$: Observable<PreventionMockModel | null> = this.refreshPrevention$.asObservable().pipe(
    switchMap((prevention) => {
      this.showNoData = false;
      return typeof prevention === 'string'
        ? this._aiPreventionService.getPreventionMockDetails(prevention)
        : of(prevention);
    }),
    tap((prevention) => this.setPreventionCards(prevention)),
    catchError((error) => this.handleErrors(error))
  );

  public preventionDetailsCardFields: ICardField[];

  constructor(
    private readonly _aiPreventionService: AiPreventionMockHttpService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService
  ) {
    effect(() => this.refreshPrevention$.next(this.prevention()));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.status === HttpStatusCode.NotFound) {
      this.showNoData = true;
    } else {
      this._httpErrorHandlerService.handle(error);
    }
    return of(null);
  }

  private setPreventionCards(prevention: PreventionMockModel) {
    this.preventionDetailsCardFields = [
      { key: 'Name:', value: prevention.name },
      { key: 'Type:', value: prevention.type },
      { key: 'Created/Sent At:', value: formatFromDate(prevention.dateCreatedSent) },
      { key: 'Created/Sent By:', value: prevention.ownerCreatedSentBy },
    ];
  }
}
